/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type InteractionLocation } from '@/types/analytics';
import { localStorage } from '@/utils/localStorage';

const interactionLocationsKey = 'interactionLocation';

const isPageTypeInInteractionLocations = (
  pageType: string,
): pageType is keyof typeof interactionLocations => {
  return pageType in interactionLocations;
};

export const getInteractionLocation = (pageType: string): string => {
  if (isPageTypeInInteractionLocations(pageType)) {
    return interactionLocations[pageType];
  }

  return pageType;
};

export const setInteractionLocation = (pageType?: string): void => {
  if (
    pageType &&
    localStorage.getItem(interactionLocationsKey) !== getInteractionLocation(pageType)
  ) {
    localStorage.setItem(interactionLocationsKey, getInteractionLocation(pageType));
  }
};

export const getStoredInteractionLocation = (): InteractionLocation => {
  return (localStorage.getItem(interactionLocationsKey) as InteractionLocation) ?? '';
};

export const clearInteractionLocation = (): void => {
  localStorage.removeItem(interactionLocationsKey);
};

const interactionLocations = {
  header: 'Universal Header',
  home: 'Inline YMME',
  category: 'Inline YMME',
  shelf: 'Inline YMME',
  ProductDetail: 'Inline YMME',
  needsMoreInfo: 'Needs more info',
  fitmentCheckFits: 'Check if it fits',
  fitmentThisFits: 'Fits your vehicle',
  fitmentThisDoesNotFit: 'Does not Fit your X',
  myVehicle: 'My Vehicle YMME',
  bundleDealsDrawer: 'bundleDealsDrawer',
  search: 'Inline YMME',
  url: 'URL',
  vinDecoder: 'VIN-Decoder',
  campaign: 'campaign',
  scanVin: 'Scan Vin',
  enterVin: 'VIN',
  licensePlateLookup: 'License Plate',
  ymmeAlert: 'Ymme Alert',
} as const;
